/* eslint-disable */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react/prop-types */
/* eslint-disable no-use-before-define */
/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from 'react';
import {
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    Paper,
    Typography,
    Box,
    Fade,
    Chip,
    IconButton,
    Menu,
    MenuItem,
    CircularProgress,
    Tooltip,
    Tabs,
    Tab,
    TextField,         
    InputAdornment,     
    FormControl,       
    InputLabel,         
    Select,           
    MenuItem as SelectMenuItem  
} from '@mui/material';
import {
    NavigateNext,
    NavigateBefore,
    MoreVert as MoreVertIcon,
    Edit as EditIcon,
    Delete as DeleteIcon,
    Block as BlockIcon,
    List as ListIcon,
    Add as AddIcon,
    Search as SearchIcon,    
    Clear as ClearIcon  
} from '@mui/icons-material';
import {useBank} from 'hooks/api/terminology/bank/useBank';
import Swal from 'sweetalert2';
import { PaginationButton, StyledTableContainer, globalColor } from '../../ConstantColors';
import { BankForm } from './add';
import { logger } from 'utils/environment/log';
import {
    AuditCell,
    ClampedText,
    ConfigurationActionMenu,
    ConfigurationPagination,
    ConfigurationStatusChip,
    stickyActionCellSx,
    stickyActionHeadSx,
    tableSx
} from '../components/ConfigurationTable';

// Toast Configuration
const Toast = Swal.mixin({
    toast: true,
    position: 'top-end',
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: true
});

// Action Menu Component
const ActionMenu = ({ bank, onEdit, onDelete, onToggleActive }) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleAction = (action) => {
        handleClose();
        action();
    };
    

    return (
        <>
            <Tooltip title="Actions">
                <IconButton onClick={handleClick}>
                    <MoreVertIcon />
                </IconButton>
            </Tooltip>
            <Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
                <MenuItem onClick={() => handleAction(onEdit)}>
                    <EditIcon sx={{ mr: 1 }} /> Edit
                </MenuItem>
                <MenuItem onClick={() => handleAction(onToggleActive)} sx={{ color: bank.isActive ? 'error.main' : 'success.main' }}>
                    <BlockIcon sx={{ mr: 1 }} /> {bank.isActive ? 'Deactivate' : 'Activate'}
                </MenuItem>
            </Menu>
        </>
    );
};

// Search Component - NEW ADDITION
const SearchSection = ({ searchTerm, setSearchTerm, searchField, setSearchField, onClearSearch, loading }) => {
    const searchFields = [
        { value: 'name', label: 'Bank Name' },
        { value: 'createdBy', label: 'Created By' },
        { value: 'updatedBy', label: 'Modified By' }
    ];

    return (
        <Box sx={{ mb: 3, display: 'flex', gap: 2, alignItems: 'center', flexWrap: 'wrap' }}>
            <FormControl size="small" sx={{ minWidth: 150 }}>
                <InputLabel>Search Field</InputLabel>
                <Select
                    value={searchField}
                    label="Search Field"
                    onChange={(e) => setSearchField(e.target.value)}
                    disabled={loading}
                >
                    {searchFields.map((field) => (
                        <SelectMenuItem key={field.value} value={field.value}>
                            {field.label}
                        </SelectMenuItem>
                    ))}
                </Select>
            </FormControl>
            
            <TextField
                size="small"
                placeholder={`Search by ${searchFields.find(f => f.value === searchField)?.label || 'Bank Name'}...`}
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                disabled={loading}
                sx={{ flexGrow: 1, maxWidth: 400 }}
                InputProps={{
                    startAdornment: (
                        <InputAdornment position="start">
                            <SearchIcon color="action" />
                        </InputAdornment>
                    ),
                    endAdornment: searchTerm && (
                        <InputAdornment position="end">
                            <IconButton size="small" onClick={onClearSearch} disabled={loading}>
                                <ClearIcon />
                            </IconButton>
                        </InputAdornment>
                    )
                }}
            />
        </Box>
    );
};

// Main Bank Component
const Bank = () => {
    const { listBank, banks, createBank, deleteBank, updateBank, getBankById } = useBank();
    const [page, setPage] = useState(0);
    const [selectedBank, setSelectedBank] = useState(null);
    const [loading, setLoading] = useState(true);
    const [activeTab, setActiveTab] = useState(0);
    const [searchTerm, setSearchTerm] = useState('');
    const [searchField, setSearchField] = useState('name');
    const rowsPerPage = 5;

    useEffect(() => {
        fetchBanks();
    }, []);

    const getFilteredBanks = () => {
        if (!searchTerm.trim()) {
            return banks;
        }

        const searchLower = searchTerm.toLowerCase().trim();
        return banks.filter((bank) => {
            const fieldValue = bank[searchField];
            if (fieldValue === null || fieldValue === undefined) {
                return false;
            }
            return String(fieldValue).toLowerCase().includes(searchLower);
        });
    };
    const filteredBanks = getFilteredBanks();

    const fetchBanks = async () => {
        setLoading(true);
        try {
            await listBank(0, 1000);
        } catch (error) {
            Toast.fire({
                icon: 'error',
                title: 'Failed to fetch banks'
            });
        } finally {
            setLoading(false);
        }
    };
    const handleClearSearch = () => {
        setSearchTerm('');
        setPage(0);
    };


    const handleSubmit = async (values, { resetForm, setSubmitting }) => {
        try {
            if (values.id && values.id !== 0) {
               
                const updateData = {
                    id: values.id,
                    name: values.name,
                    isDeleted: values.isDeleted,
                    createdBy: values.createdBy,
                    updatedBy: values.updatedBy,
                    createdAt: values.createdAt,
                    updatedAt: new Date().toISOString()
                };
                await updateBank(values.id, updateData);
            } else {
                // Create new bank
                const createData = {
                    name: values.name,
                    isDeleted: false,
                    createdBy: values.createdBy,
                    updatedBy: values.updatedBy,
                    createdAt: new Date().toISOString(),
                    updatedAt: new Date().toISOString()
                };
                await createBank(createData);
            }

            await fetchBanks();
            resetForm();
            setSelectedBank(null);
            setActiveTab(0);

            Toast.fire({
                icon: 'success',
                title: `Bank ${values.id ? 'updated' : 'added'} successfully`
            });
        } catch (error) {
            logger.error('Error in handleSubmit:', error);
            Toast.fire({
                icon: 'error',
                title: `Failed to ${values.id ? 'update' : 'add'} bank`
            });
        } finally {
            setSubmitting(false);
        }
    };

    const handleEditClick = async (bank) => {
        try {
            let bankToEdit = bank;
            setSelectedBank(bankToEdit);
            setActiveTab(1); // Switch to form tab
            window.scrollTo({ top: 0, behavior: 'smooth' });
        } catch (error) {
            Toast.fire({
                icon: 'error',
                title: 'Failed to fetch bank details'
            });
        }
    };

    const handleDeleteClick = async (bank) => {
        const result = await Swal.fire({
            title: 'Are you sure?',
            text: `Do you want to delete "${bank.name}"? You won't be able to revert this!`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            cancelButtonColor: '#3085d6',
            confirmButtonText: 'Yes, delete it!'
        });

        if (result.isConfirmed) {
            try {
                await deleteBank(bank.id);
                await fetchBanks();
                Toast.fire({
                    icon: 'success',
                    title: 'Bank deleted successfully'
                });
            } catch (error) {
                Toast.fire({
                    icon: 'error',
                    title: 'Failed to delete bank'
                });
            }
        }
    };

    const handleToggleActive = async (bank) => {
        const isActive = !bank.isDeleted;
        const action = isActive ? 'deactivate' : 'activate';
        const result = await Swal.fire({
            title: `Are you sure?`,
            text: `Do you want to ${action} this bank?`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: isActive ? '#d33' : '#28a745',
            cancelButtonColor: '#3085d6',
            confirmButtonText: `Yes, ${action} it!`
        });

        if (result.isConfirmed) {
            try {
                await updateBank(bank.id, {
                    ...bank,
                    isDeleted: isActive
                });
                await fetchBanks();
                Toast.fire({
                    icon: 'success',
                    title: `Bank ${action}d successfully`
                });
            } catch (error) {
                Toast.fire({
                    icon: 'error',
                    title: `Failed to ${action} bank`
                });
            }
        }
    };

    const handleTabChange = (event, newValue) => {
        setActiveTab(newValue);
        if (newValue === 0) {
            setSelectedBank(null);
        }
    };

    const renderBankForm = () => (
        <Fade in timeout={1000}>
            <Box>
                <BankForm
                    initialData={selectedBank}
                    onSubmit={handleSubmit}
                    onClear={() => {
                        setSelectedBank(null);
                        setActiveTab(0);
                    }}
                />
            </Box>
        </Fade>
    );

    const renderBankList = () => (
        <Box sx={{ mt: 4 }}>

<SearchSection
                searchTerm={searchTerm}
                setSearchTerm={(value) => {
                    setSearchTerm(value);
                    setPage(0);
                }}
                searchField={searchField}
                setSearchField={setSearchField}
                onClearSearch={handleClearSearch}
                loading={loading}
            />
 <Box sx={{ mb: 2 }}>
                <Typography variant="body2" color="text.secondary">
                    {searchTerm ? (
                        <>
                            Showing {filteredBanks.length} of {banks.length} banks 
                            {filteredBanks.length > 0 && ` matching "${searchTerm}"`}
                        </>
                    ) : (
                        <>Total: {banks.length} banks</>
                    )}
                </Typography>
            </Box>
           {loading ? (
                <Box display="flex" justifyContent="center" alignItems="center" sx={{ mt: 4 }}>
                    <CircularProgress color="primary" />
                </Box>
            ) : (
                <Fade in timeout={1500}>
                    <StyledTableContainer component={Paper}>
                        <Table size="small" sx={tableSx(700)}>
                            <TableHead>
                                <TableRow>
                                    <TableCell>Name</TableCell>
                                    <TableCell sx={{ width: 138 }}>Created</TableCell>
                                    <TableCell sx={{ width: 138 }}>Updated</TableCell>
                                    <TableCell sx={{ width: 92 }}>Status</TableCell>
                                    <TableCell align="center" sx={stickyActionHeadSx}>Actions</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                            {filteredBanks.length > 0 ? (
                                    filteredBanks.slice(page * rowsPerPage, (page + 1) * rowsPerPage).map((bank) => (
                                        <TableRow key={bank.id}>
                                            <TableCell><ClampedText>{bank.name}</ClampedText></TableCell>
                                            <TableCell><AuditCell by={bank.createdBy} at={bank.createdAt} /></TableCell>
                                            <TableCell><AuditCell by={bank.updatedBy} at={bank.updatedAt} /></TableCell>
                                            <TableCell>
                                                <ConfigurationStatusChip active={!bank.isDeleted} />
                                            </TableCell>
                                            <TableCell align="center" sx={stickyActionCellSx}>
                                                <ConfigurationActionMenu
                                                    label={bank.name}
                                                    actions={[
                                                        { label: 'Edit', icon: EditIcon, onClick: () => handleEditClick(bank) },
                                                        {
                                                            label: bank.isDeleted ? 'Activate' : 'Deactivate',
                                                            icon: BlockIcon,
                                                            color: bank.isDeleted ? '#25643b' : '#b54708',
                                                            onClick: () => handleToggleActive(bank)
                                                        }
                                                    ]}
                                                />
                                            </TableCell>
                                        </TableRow>
                                    ))
                                ) : (
                                    <TableRow>
                                        <TableCell colSpan={5} align="center">
                                            {}
                                            <Box sx={{ py: 4 }}>
                                                <Typography variant="body1" color="text.secondary">
                                                    {searchTerm ? (
                                                        <>
                                                            No banks found matching "{searchTerm}" in {searchField}
                                                            <Box sx={{ mt: 2 }}>
                                                                <Typography 
                                                                    variant="body2" 
                                                                    color="primary" 
                                                                    sx={{ cursor: 'pointer', textDecoration: 'underline' }}
                                                                    onClick={handleClearSearch}
                                                                >
                                                                    Clear search to view all banks
                                                                </Typography>
                                                            </Box>
                                                        </>
                                                    ) : (
                                                        'No banks available'
                                                    )}
                                                </Typography>
                                            </Box>
                                        </TableCell>
                                    </TableRow>
                                )}
                            </TableBody>
                        </Table>

                        <ConfigurationPagination
                            page={page}
                            rowsPerPage={rowsPerPage}
                            total={filteredBanks.length}
                            onPageChange={setPage}
                        />
                    </StyledTableContainer>
                </Fade>
            )}
        </Box>
    );

    return (
        <Box sx={{ p: 3 }}>
            <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 3 }}>
                <Tabs
                    value={activeTab}
                    onChange={handleTabChange}
                    sx={{
                        '& .MuiTab-root': {
                            fontSize: '1rem',
                            textTransform: 'none'
                        }
                    }}
                >
                    <Tab icon={<ListIcon />} iconPosition="start" label="Banks List" />
                    <Tab icon={<AddIcon />} iconPosition="start" label={selectedBank ? 'Edit Bank' : 'Add Bank'} />
                </Tabs>
            </Box>

            {activeTab === 0 ? renderBankList() : renderBankForm()}
        </Box>
    );
};

export default Bank;
